const url = 'payment-history-service/v1/receipts';
export const fetchPaymentHistory = (fromDate: string, toDate: string) => {
	return {
		url: `${url}?fromDate=${fromDate}&toDate=${toDate}`,
		method: 'GET',
	};
};
